import styled from 'styled-components';
import { Button, Input } from 'antd';

export const SAssigneeSearchInput = styled(Input)`
  border-radius: 4px;
`;

export const SAssigneePersonItem = styled.div`
  cursor: pointer;
  padding: 8px 12px;
  border-radius: 4px;
  &:hover {
    background-color: #f5f5f5;
  }
`;

export const SAssigneeTriggerButton = styled(Button)`
  padding: 0;
  height: auto;
  text-align: left;
  background: transparent;
  border: none;
  box-shadow: none;
  &:hover,
  &:focus {
    background: transparent;
  }
`;
